<template>
  <SvgIcon :icon-class="`signal-${type}`" />
</template>
<script>
import { SIGNALTYPES } from '@/utils/constant'

export default {
  name: 'SignalIcon',
  model: {
    prop: 'value'
  },
  props: {
    value: {
      type: Number,
      required: true
    }
  },
  computed: {
    type () {
      let r = ''
      Object.keys(SIGNALTYPES).forEach(k => {
        if (SIGNALTYPES[k].includes(this.value)){
          r = k.toLocaleLowerCase()
        }
      })
      return r
    }
  }
}
</script>
